import { scaffolderPlugin } from "@backstage/plugin-scaffolder";
import { createScaffolderFieldExtension } from "@backstage/plugin-scaffolder-react";
import { ScaledObjectListField } from "./ScaledObjectListField";

// @TODO: Fix the typing issues
export const ScaledObjectListFieldExtension: any = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: "ScaledObjectListField",
    component: ScaledObjectListField,
  })
);
